
<template>
  <!--封禁管理-->
  <div>
    <a-button v-hasPermi="['neighbour:banManage:add']" :style="{ marginBottom: '20px' }" type="primary" @click="$router.push({name: 'addBan', query: {title: '新增封禁'}})">新增封禁</a-button>

    <a-tabs v-model="tabType" type="card">
      <a-tab-pane v-for="item of tabList" :key="item.key" :tab="item.label">
        <ban v-if="tabType === item.key" :tabType="tabType"></ban>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import ban from '@/components/package/ban.vue';
export default {
  components: {
    ban
  },
  name: 'banManage',
  data () {
    return {
      tabType: '1',
      tabList: [
        { label: '禁言管理', key: '1' },
        { label: '禁止发布动态', key: '2' },
        { label: '禁止评论回复', key: '3' }
      ]
    };
  },
  created () {
  },
  methods: {
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>
